import React, {Component} from 'react'
import './App.css'
import Header from 'components/common/header_v2/index.js'
import Footer from 'components/common/footer/index.js'
import createHistory from 'history/createBrowserHistory';
import Routes from 'routes'
//[mh] chatbot turned off in 3.31.7; restore this import and <Chatbot/> to bring it back
// import Chatbot from 'features/chatbot/index.js'
import {CircleArrow as ScrollUpButton} from 'components/back-to-top'

const history = createHistory();

class App extends Component {
    render() {
        return (
            <div className="app">
                <Header history={history}/>
                <Routes/>
                <ScrollUpButton/>
                <Footer/>
            </div>
        )
    }
}

export default App
